import { Component } from "@angular/core";

@Component({
	selector: 'dms-simpleselect',
	templateUrl: './simpleselect.component.html',
})
export class SimpleSelectComponent {

}